module.exports = __webpack_public_path__ + "static/media/PSC-Inspections.632e36fa.jpg";